import { State } from './state.type';

export const stateInitializer = (): State => {
	return {
		contactId: '',
		firstName: '',
		lastName: '',
		email: '',
		zipcode: '',
		phone: '',
		address: '',
		city: '',
		state: '',
		country: ''
	};
};
